module.exports = __webpack_public_path__ + "img/Owners_manual.53cba0de.jpg";